// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "b48089e6" + "." + "c8631e78a77d1146" + ".js";
};